import type { Answer } from "types/answer";
import type { Question } from "types/question";
import { findAnswersByQuestionTag } from "./questions";
import { WHY_LOSE_WEIGHT } from "config/tags";

export const whyLoseWeight = (
  answers?: Answer[],
  questions?: Question[]
): string => {
  if (!answers?.length || !questions?.length) {
    return "";
  }

  const whyLoseWeightAnswers = findAnswersByQuestionTag(
    WHY_LOSE_WEIGHT,
    answers,
    questions
  )[0]?.answers?.map(answer => answer.value);

  if (!whyLoseWeightAnswers?.length) {
    return "";
  }

  return whyLoseWeightAnswers.length === 1
    ? ` and ${whyLoseWeightAnswers[0]}.`
    : `, ${whyLoseWeightAnswers.slice(0, -1).join(", ")} and ${whyLoseWeightAnswers[whyLoseWeightAnswers.length - 1]}.`;
};
